import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';

/* Note */
/* Params: isLoadMore to check user have load more yet */
export default function blockListReducer(state = initialState.blockList, action) {
  switch (action.type) {
    case types.UPDATE_BLOCK_LIST_STATE: {
      return state.merge({ ...action.data });
    }
    case types.GET_BLOCK_LIST_SUCCESS: {
      const { data } = Immutable.asMutable(state);
      let updateParams = {};
      updateParams = {
        isLoading: false,
        isCalled: true,
        data: action.params && action.params.isLoadMore ? [...data, ...action.data] : action.data,
        isHasMore: !(action.data instanceof Array && action.data.length < (action.params.pageSize || 25)),
        page: action.params.page,
        isCallingLoadMore: false,
      };
      return state.merge({ ...updateParams });
    }
    case types.DELETE_BLOCK_SUCCESS: {
      const { data } = Immutable.asMutable(state);
      const update = data.filter(item => item.user.userId !== action.userId);
      return state.merge({ data: update });
    }
    case types.USER_LOGOUT_SUCCESS: {
      const reset = {
        data: [],
        page: 1,
        isLoading: false,
        isHasMore: true,
      };
      return state.merge({
        ...reset,
      });
    }

    default:
      return state;
  }
}
